import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/authContext';

function ProtectedRoute() {
  const { currentUser } = useAuth();
  
  // currentUser가 있으면 자식 라우트(Outlet)를 렌더링하고,
  // 없으면 홈('/')으로 리디렉션합니다.
  return currentUser ? <Outlet /> : <Navigate to="/" replace />;
}

export default ProtectedRoute;